import { getTvObject, tv } from '@costar-ui/cosmos';

var propertyImageTV = getTvObject({
  base: ['border', 'border-neutral', 'rounded'],
  //base = common styles
  variants: {
    size: {
      md: ['w-[10.688rem]', 'h-[7.5rem]', 'min-w-[10.688rem]'],
      // 171px x 120px
      lg: ['w-[14.875rem]', 'h-[10.625rem]', 'min-w-[14.875rem]'],
      // 238px x 170
      xl: ['w-[19.25rem]', 'h-[13.75rem]', 'min-w-[19.25rem]'] // 308px x 220px
    }
  }
});
var base = {
  base: tv(propertyImageTV)
};
var propertyImageStyles = {
  base: base
};

export { propertyImageStyles, propertyImageTV };
//# sourceMappingURL=property-image.styles.esm.js.map
